<span mat-icon-button [matMenuTriggerFor]="menu" stopPropagation>
    <mat-icon svgIcon="aumico-pattern-icon-settings-vertical"></mat-icon>
</span>
<mat-menu #menu="matMenu">
    <button
        class="aum-menu-item"
        mat-menu-item
        *ngFor="let item of items"
        (click)="onClick(item, $event)"
        [disabled]="item.disabled"
        [id]="item.action"
    >
        <mat-icon [class.disabled]="item.disabled" *ngIf="item.icon" [svgIcon]="item.icon"></mat-icon>
        <span>{{ item.caption }}</span>
    </button>
</mat-menu>
